import styled from "styled-components";
import { rem, em } from "convert-to-ems";

export const ButtonElement = styled.button.attrs(props => ({ disabled: props.disabled }))`
  width: ${props => (props.widthPercent ? props.widthPercent : rem(props.width))};
  height: ${props => (props.height ? rem(props.height) : rem(51))};
  margin-top: ${props => rem(props.marginTop)};
  ${props =>
    props.marginLeft && typeof props.marginLeft === "number"
      ? `margin-left: ${rem(props.marginLeft)}`
      : `margin-left: ${props.marginLeft}`};
  ${props =>
    props.marginBottom && typeof props.marginBottom === "number"
      ? `margin-bottom: ${rem(props.marginBottom)}`
      : `margin-bottom: ${props.marginBottom}`};
  display: flex;
  flex-direction: row;
  justify-content: ${props => !props.src && "center"};
  align-items: center;
  border: ${props => (props.border ? "solid 2px" : "none")};
  border-width: ${props => (props.borderColor ? "1px" : "2px")};
  border-color: ${props => (props.borderColor ? props.borderColor : "#E0E2E9")};
  border-radius: ${props => (props.borderRadius ? props.borderRadius : "24px")};
  background: ${props => props.backgroundColor};
  color: ${props => props.textColor};
  opacity: ${props => (props.disabled ? 0.3 : 1)};
  z-index: ${props => props.zIndex};
  text-decoration: ${props => props.textDecoration};

  p {
    font-size: ${props => (props.fontSize ? em(props.fontSize) : "")};
    margin-left: ${props =>
      props.src && props.marginLeftText ? props.marginLeftText : props.src && rem(16)};
    font-family: ${props => props.theme.baseFontFamily};
    font-weight: ${props => props.fontWeight};
    padding-top: ${rem(3)};
    letter-spacing: ${props =>
      Number.isNaN(props.letterSpacing) ? props.letterSpacing : em(props.letterSpacing)};
    line-height: ${props =>
      Number.isNaN(props.lineHeight) ? props.lineHeight : em(props.lineHeight)};
  }
`;

export const Icone = styled.img`
  margin-left: ${props => rem(props.marginLeftImg)};
`;
